import React, { useEffect, useState } from 'react';
import { Link, useToast } from '@chakra-ui/react';
import AuthApi from '../../../api/auth';

const CountdownTimer = ({ seconds: initialSeconds, otpID }) => {
  const [timeRemaining, setTimeRemaining] = useState(initialSeconds);
  const toast = useToast();

  useEffect(() => {
    toast({
      title: 'Verification code is sent to your email',
      status: 'success',
      duration: 5000,
      isClosable: true,
      position: 'top',
    });
  }, [toast]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeRemaining]);

  const resendOTP = async () => {
    try {
      const response = await AuthApi.ResendOTP({ otp_id: otpID });
      if (response.data.status_code === 200) {
        toast({
          title: response?.data?.message,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        setTimeRemaining(initialSeconds); // Reset timer after resending OTP
      } else {
        toast({
          title: 'Failed to resend OTP. Please try again.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (error) {
      toast({
        title: 'An error occurred. Please try again later.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
  };

  return (
    <p>
      {timeRemaining > 0 ? (
        <>Didn't get an OTP ? Resend in {formatTime(timeRemaining)}</>
      ) : (
        <Link fontSize='sm' onClick={resendOTP}>
          Resend OTP
        </Link>
      )}
    </p>
  );
};

export default CountdownTimer;
